import { useAppStore } from 'App/store';
import { useOrderRequestStore } from 'Order/store';
import isEmpty from 'lodash/isEmpty';
import { useMemo } from 'react';
import { EntityType } from 'shared/constants/entityTypes';
import { isPanelType } from '../../utils/misc';

export function useAsyncSelectTurnaround({
  entityType,
  fieldTypeEntityReference,
} = {}) {
  const {
    appState: { filterTATByAssayEnabled },
  } = useAppStore();
  const { assayToAdd: assayOrPanel } = useOrderRequestStore() || {};
  const isPanel = isPanelType(assayOrPanel);

  // Turnaround needs a special handling when
  // `FILTER_TAT_BY_ASSAY_ENABLED` is on.
  const assayId = assayOrPanel?.id;
  const isTestTurnaround =
    entityType === EntityType.TEST &&
    fieldTypeEntityReference === EntityType.TURNAROUND;

  const turnaroundParams = useMemo(() => {
    if (
      !filterTATByAssayEnabled ||
      !isTestTurnaround ||
      !assayId ||
      isEmpty(assayOrPanel)
    )
      return;
    return {
      assay_ids: isPanel
        ? (assayOrPanel.panel_assays || []).map((pa) => pa.assay_id)
        : assayId,
    };
  }, [
    isTestTurnaround,
    filterTATByAssayEnabled,
    assayOrPanel,
    assayId,
    isPanel,
  ]);

  return turnaroundParams;
}
